import { render } from "./HeaderTooltip.vue?vue&type=template&id=48ca699b"
import script from "./HeaderTooltip.vue?vue&type=script&lang=js"
export * from "./HeaderTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__